class CustomSimpleSlider {
  constructor(containerSelector, sliderSelector, slideSelector) {
    this.container = document.querySelector(containerSelector);

    if (!this.container) {
      return;
    }

    this.slider = document.querySelector(sliderSelector);
    this.slides = document.querySelectorAll(slideSelector);
    this.currentX = 0;
    this.startX = 0;
    this.isSwiping = false;

    this.addEventListeners();
  }

  addEventListeners() {
    this.container.addEventListener('wheel', (e) => {
      e.preventDefault();
      let slideWidth = this.slides[0].offsetWidth;
      if (e.deltaY > 0) {
        this.currentX -= slideWidth;
      } else {
        this.currentX += slideWidth;
      }
      this.applyConstraints();
      this.slider.style.transform = `translate3d(${this.currentX}px, 0px, 0px)`;
    });

    this.slider.addEventListener('touchstart', (e) => {
      this.isSwiping = true;
      this.slider.style.transition = 'none';
      this.startX = e.touches[0].clientX;
    });

    this.slider.addEventListener('touchmove', (e) => {
      if (!this.isSwiping) return;

      const touchX = e.touches[0].clientX;
      const deltaX = touchX - this.startX;

      this.currentX += deltaX;
      this.slider.style.transform = `translate3d(${this.currentX}px, 0px, 0px)`;
      this.startX = touchX;
    });

    this.slider.addEventListener('touchend', (e) => {
      this.isSwiping = false;
      this.slider.style.transition = 'transform 0.2s ease-out';

      const touchEndX = e.changedTouches[0].clientX;
      const deltaX = touchEndX - this.startX;
      const slideWidth = this.slides[0].offsetWidth;

      if (Math.abs(deltaX) > slideWidth) {
        if (deltaX < 0) {
          this.currentX -= slideWidth;
        } else {
          this.currentX += slideWidth;
        }
      }
      this.applyConstraints();
      this.slider.style.transform = `translate3d(${this.currentX}px, 0px, 0px)`;
    });
  }

  applyConstraints() {
    const containerWidth = this.container.offsetWidth;
    const sliderWidth = this.slider.scrollWidth;
    const maxOffset = containerWidth - sliderWidth;

    if (this.currentX > 0) {
      this.currentX = 0;
    } else if (this.currentX < maxOffset) {
      this.currentX = maxOffset;
    }
  }
}